// compare-chart-line.js
(function () {
  const MOBILE_MAX = 767;

  function initCompareSection(sectionEl) {
    if (!sectionEl) return;

    const glideEl = sectionEl.querySelector('.glide--compare-chart');
    if (!glideEl) return;

    const slides = glideEl.querySelectorAll('.glide__slide');
    if (slides.length <= 1) {
      // No need for a slider if only one slide
      sectionEl.classList.add('is-static');
      if (sectionEl._glide) {
        sectionEl._glide.destroy();
        sectionEl._glide = null;
      }
      return;
    }

    // Only mount on mobile widths
    if (window.innerWidth > MOBILE_MAX) {
      if (sectionEl._glide) {
        sectionEl._glide.destroy();
        sectionEl._glide = null;
      }
      return;
    }

    // Already mounted? bail.
    if (sectionEl._glide) return;

    const glide = new Glide(glideEl, {
      type: 'carousel',
      perView: 1.2,
      focusAt: 0,
      bound: true,
      gap: 12,
      breakpoints: {
        768: { perView: 1.2, gap: 12 }
      }
    });

    glide.mount();
    sectionEl._glide = glide;
  }

  function initAll() {
    document.querySelectorAll('.section--compare-chart').forEach(initCompareSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // Handle resize: mount on mobile, destroy on desktop
  window.addEventListener('resize', () => {
    document.querySelectorAll('.section--compare-chart').forEach(initCompareSection);
  });

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.matches('.section--compare-chart, .shopify-section--compare-chart')) {
      initCompareSection(e.target);
    }
  });
  document.addEventListener('shopify:section:unload', (e) => {
    const sec = e.target;
    if (sec && sec._glide) {
      sec._glide.destroy();
      sec._glide = null;
    }
  });
})();
